import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  user_readUserNotificationData: any;
  user_readUserNotificationLoading: boolean;
  user_readUserNotificationError: SerializedError | null;
} = {
  user_readUserNotificationData: {},
  user_readUserNotificationLoading: false,
  user_readUserNotificationError: null,
};

export const user_readUserNotificationFunc = createAsyncThunk(
  'user_readUserNotification/user_readUserNotificationFunc',
  async (values: { uid: string }) => {
    const accessTokenJSON = localStorage.getItem('auth') as string;
    const data1 = JSON.stringify({
      query: `mutation User_readUserNotification($uid: String!) {
        user_readUserNotification(uid: $uid) {
            success
        }
    }`,
      variables: {
        uid: values?.uid,
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_NOTIFICATION || '',
      data1,
      JSON.parse(accessTokenJSON)?.accessToken || ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const user_readUserNotification = createSlice({
  name: 'user_readUserNotification',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(user_readUserNotificationFunc.pending, (state) => {
      state.user_readUserNotificationLoading = true;
    });
    builder.addCase(user_readUserNotificationFunc.fulfilled, (state, action) => {
      state.user_readUserNotificationLoading = false;
      state.user_readUserNotificationData = action.payload?.data?.user_readUserNotification?.data;
      state.user_readUserNotificationError =
        action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(user_readUserNotificationFunc.rejected, (state, action) => {
      state.user_readUserNotificationLoading = false;
      state.user_readUserNotificationError = action.error;
    });
  },
});

export default user_readUserNotification.reducer;
